import gsap from "gsap";
import classNames from "classnames/bind";
import { useEffect, useRef, useState } from "react";
import TicketRow from "./TicketRow";
import { getLinkData } from "@/core/utils";
import { useTicketing } from "../../TicketingProvider";
import ArrowRight from '@/assets/svg/arrow-right.svg';
import { TicketingFragment } from "@graphqlTypes";
import { RhLink } from "@components";

import styles from '../TicketingForm.module.scss';
const cx = classNames.bind(styles);

type IncludedTicket = TicketingFragment['ticketingForm']['discountedTickets']['ticketsIncluded']['nodes'][number];

const IncludedTicket = (props: IncludedTicket) => {
  if (props.__typename !== "TicketPrice") return null;
  const {
    title,
    ticketPriceFields: {
      ticketing: {
        title: ticketingTitle,
        description,
        cta
      }
    }
  } = props;
  const ctaData = cta ? getLinkData(cta) : null;
  return (
    <div className={cx("included-ticket")}>
      <p className={cx(["text-m", "title"])}>{ticketingTitle || title}</p>
      { description && <p className={cx("text-s")}>{description}</p> }
      { ctaData && (
        <RhLink className={cx(["inline-link", "link"])} data-gtm-section="ticket-form" href={ctaData.url} target={ctaData.target}>
          {ctaData.label}
        </RhLink>
      )}
    </div>
  )

};

export default function TicketingAccordion() {
  const {
    data: {
      discountedTickets: {
        accordionLabel,
        discountedTicket,
        ticketsIncluded
      }
    }
  } = useTicketing();
  const [expanded, setExpanded] = useState(false);
  const contentEl =  useRef<HTMLDivElement | null>(null);
  const contentWrapperEl = useRef<HTMLDivElement | null>(null);
  const animateAccordion = (expanded: boolean) => {
    if (!contentEl.current || !contentWrapperEl.current) return;
    const tl = gsap.timeline();
    if (!expanded) {
      tl.to(contentWrapperEl.current, { height: 0, duration: 0.3, ease: "power1.out" });
      tl.set(contentWrapperEl.current, { visibility: "hidden" });
    } else {
      const { offsetHeight } = contentEl.current;
      tl.set(contentWrapperEl.current, { visibility: "visible" });
      tl.to(contentWrapperEl.current, { height: offsetHeight, duration: 0.3, ease: "power1.out" });
    }
  };
  useEffect(() => {
    animateAccordion(expanded);
  }, [expanded])
  return (
    <div className={cx("ticketing-accordion")}>
      <button className={cx("button")} type="button" aria-expanded={expanded} onClick={() => setExpanded(!expanded)}>
        <span className="text-m">{accordionLabel}</span>
        <ArrowRight className={cx(["icon", { expanded }])} />
      </button>
      <div className={cx("ticketing-accordion__content-wrapper")} ref={contentWrapperEl}>
        <div className={cx("ticketing-accordion__content")} ref={contentEl}>
          {ticketsIncluded?.nodes.map((ticket, index) => (
            <IncludedTicket key={index} {...ticket} />
          ))}
          <TicketRow ticket={discountedTicket.node} />
        </div>
      </div>
    </div>
  );
}